import { Controller } from "stimulus";
import StimulusReflex from "stimulus_reflex";

export default class extends Controller {
  static targets = [
    "addressLine1",
    "addressLine2",
    "zipCode",
    "city",
    "state",
    "errorMessageContainer",
    "validationFlag",
    "successMessageContainer",
    "validateButtonContainer",
    "validateButton",
    "validatingSpinner",
  ];

  connect() {
    StimulusReflex.register(this);
    this.toggleSubmitButton();
    const hiddenField = this.validationFlagTarget;
    const validationObserver = new MutationObserver(() => {
      this.toggleSubmitButton();
    });

    validationObserver.observe(hiddenField, {
      attributes: true,
      attributeFilter: ["value"],
    });
  }

  validateAddress() {
    let isValid = true;
    let firstErrorField = null;

    [
      this.addressLine1Target,
      this.cityTarget,
      this.stateTarget,
      this.zipCodeTarget,
    ].forEach((field) => {
      field.value = field.value.trim();
      if (!field.checkValidity()) {
        field.classList.add("field-error");
        isValid = false;
        if (!firstErrorField) firstErrorField = field;
      }
    });

    if (!isValid) {
      this.errorMessageContainerTarget.classList.remove("hidden");
      if (firstErrorField) firstErrorField.reportValidity();
      return;
    }

    this.errorMessageContainerTarget.classList.add("hidden");
    this.disableFields(true);
    this.validatingSpinnerTarget.classList.remove("hidden");

    this.stimulate(
      "AddressValidation#validate_address",
      this.addressLine1Target.value,
      this.addressLine2Target.value,
      this.zipCodeTarget.value,
      this.cityTarget.value,
      this.stateTarget.value
    )
      .then((response) => {
        this.disableFields(false);
        this.toggleErrorMessage();
      })
      .catch((promise) => {
        this.toggleErrorMessage();
      });
  }

  toggleErrorMessage() {
    if (this.validationFlagTarget.value == "true") {
      this.errorMessageContainerTarget.classList.add("hidden");
    } else {
      this.errorMessageContainerTarget.classList.remove("hidden");
    }
  }

  disableFields(state) {
    [
      this.addressLine1Target,
      this.addressLine2Target,
      this.cityTarget,
      this.stateTarget,
      this.zipCodeTarget,
    ].forEach((field) => (field.disabled = state));
  }

  validateField(event) {
    const field = event.target;
    const isValidated = this.validationFlagTarget.value === "true";
    this.validateButtonTarget.disabled = false;

    field.classList.toggle("field-error", field.value.trim() === "");

    if (isValidated) {
      this.validationFlagTarget.value = "false";
      this.toggleSubmitButton();
    }
  }

  toggleSubmitButton() {
    const submitButton = document.getElementById("batch_application_submit");
    const isValid = this.validationFlagTarget.value === "true";
    this.validatingSpinnerTarget.classList.add("hidden");
    submitButton.disabled = !isValid;

    if (isValid) {
      this.validateButtonContainerTarget.classList.add("hidden");
      this.successMessageContainerTarget.classList.remove("hidden");
    } else {
      this.validateButtonContainerTarget.classList.remove("hidden");
      this.successMessageContainerTarget.classList.add("hidden");
    }
  }

  copyAddress(event) {
    this.addressLine1Target.value = event.currentTarget.dataset.addressLine;
    this.cityTarget.value = event.currentTarget.dataset.city;
    this.stateTarget.value = event.currentTarget.dataset.state;
    this.zipCodeTarget.value = event.currentTarget.dataset.zipCode;
    this.validateButtonTarget.focus();
    this.validateAddress();
  }
}
